export default __webpack_public_path__ + "static/hearteyes-9373f2e8e69e0f7e4c62c54f6622e3f3.gif";